import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../../Helper/ToastMessage";

export const WTPRecirculationOfPupmTableDataAPI = createAsyncThunk("WTPRecirculationOfPupmTableData", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        FromDate,
        M_WardID,
        ToDate,
        M_UserID,
        token,
        From,
        To,
        handleGetExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    // return fetch(`${BaseUrl}/Master/Get_WEB_WTP_T_WTP_Recirculation_Pump_Select?FromDate=${FromDate}&ToDate=${ToDate}&M_WardID=${M_WardID}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_WTP_T_WTP_Recirculation_Pump_Select?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&Date=${FromDate}&M_WardID=${M_WardID}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleGetExport && handleGetExport()
                return result.data

            } else {
                return result
            }
        })
})

const WTPRecirculationOfPupmTableDataSlice = createSlice({
    name: "WTPRecirculationOfPupmTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPRecirculationOfPupmTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPRecirculationOfPupmTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WTPRecirculationOfPupmTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WTPRecirculationOfPupmTableDataReducer = WTPRecirculationOfPupmTableDataSlice.reducer

// Export API

export const WTPRecirculationOfPupmExportTableDataAPI = createAsyncThunk("WTPRecirculationOfPupmExportTableData", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        FromDate,
        M_WardID,
        ToDate,
        M_UserID,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_WTP_T_WTP_Recirculation_Pump_Select?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&Date=${FromDate}&M_WardID=${M_WardID}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data

            } else {
                return result
            }
        })
})

const WTPRecirculationOfPupmExportTableDataSlice = createSlice({
    name: "WTPRecirculationOfPupmExportTableData",
    initialState: {
        isExportLoading: false,
        ExporttableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPRecirculationOfPupmExportTableDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(WTPRecirculationOfPupmExportTableDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExporttableData = action.payload;
        });
        builder.addCase(WTPRecirculationOfPupmExportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExporttableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WTPRecirculationOfPupmExportTableDataReducer = WTPRecirculationOfPupmExportTableDataSlice.reducer


// Delete API

export const WTPRecirculationOfPupmDeleteAPI = createAsyncThunk("WTPRecirculationOfPupmDelete", async ({ data }) => {

    const {
        T_WTP_Recirculation_PumpID,
        M_UserID,
        handleIsPost,
        token,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_WTP_Recirculation_PumpID", T_WTP_Recirculation_PumpID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    // return fetch(`${BaseUrl}/Master/WEB_WTP_T_WTP_Recirculation_Pump_Delete`, requestOptions)
    return fetch(`${BaseUrl}/APKDashboard/WEB_WTP_T_WTP_Recirculation_Pump_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                // handleDeleteCloseClick()
            } else {
                toastErrorr(result.message)
                // handleDeleteCloseClick()
            }
            return result

        })
})

const WTPRecirculationOfPupmDeleteSlice = createSlice({
    name: "WTPRecirculationOfPupmDelete",
    initialState: {
        isDeleteLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPRecirculationOfPupmDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(WTPRecirculationOfPupmDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.tableData = action.payload;
            toastSuccesss(action.payload.message)
        });
        builder.addCase(WTPRecirculationOfPupmDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WTPRecirculationOfPupmDeleteReducer = WTPRecirculationOfPupmDeleteSlice.reducer